import { BookmarkIcon } from '@/icons/BookmarkIcon';
import { FollowIcon } from '@/icons/FollowIcon';
import LoginIcon from '@/icons/LoginIcon';
import { useAuth } from '@/providers/AuthProvider';
import { cn } from '@pulsex/utils';

export const LoginUserButton = ({ className }: { className?: string }) => {
    const { authUser, login } = useAuth();

    return (
        <div className={cn(className)}>
            {authUser ? (
                <>
                    {authUser.photoURL ? (
                        <img
                            src={authUser.photoURL}
                            alt="Profile"
                            className="w-9 h-9 rounded-full"
                        />
                    ) : (
                        <LoginIcon className="fill-black group-hover:fill-masterRed" size={22} />
                    )}
                </>
            ) : (
                <button
                    type="button"
                    onClick={login}
                    aria-label="تسجيل الدخول"
                    className="border w-9 h-9 p-1 rounded-full grid place-items-center group"
                >
                    <LoginIcon className="fill-black group-hover:fill-masterRed" size={22} />
                </button>
            )}
        </div>
    );
};

export const BookmarkPageButton = () => {
    const { authUser } = useAuth();

    return authUser ? (
        <a href="/bookmark" className="border rounded-full p-1 group">
            <BookmarkIcon className="stroke-black group-hover:stroke-masterRed" size={22} />
        </a>
    ) : (
        <div
            className="border rounded-full p-1 opacity-85 pointer-events-none"
            title="Login to access bookmarks"
        >
            <BookmarkIcon className="stroke-gray-400" size={22} />
        </div>
    );
};

export const LogoutButton = ({ clickEvent }: { clickEvent?: () => void }) => {
    const { logout, authUser } = useAuth();

    const handleLogout = () => {
        logout();
        clickEvent && clickEvent();
    };

    if (!authUser) return;

    return (
        <button onClick={handleLogout} className="py-1 px-2 border rounded-md">
            Log out
        </button>
    );
};

export const FollowingPageButton = () => {
    const { authUser } = useAuth();

    return authUser ? (
        <a href="/following" className="border rounded-full p-1 group">
            <FollowIcon className="stroke-black group-hover:stroke-masterRed" size={22} />
        </a>
    ) : (
        <div
            className="border rounded-full p-1 opacity-85 pointer-events-none"
            title="Login to access following"
        >
            <FollowIcon className="stroke-gray-400" size={22} />
        </div>
    );
};
